import {Component, OnInit} from '@angular/core';
import {LogLevel, LogResource, ViewportTab} from '@app/modules/shared/data/constants';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {AssignmentAction, AssignmentState, AssignmentStateModel} from '@app/state/assignment.state';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LogService} from '@app/services/log.service';
import {AssignmentService} from '@app/modules/whiteboard/services/assignment.service';


@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html'
})
export class AssignmentComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ViewportTab = ViewportTab;
  public classroom: ClassroomStateModel;
  public assignment: AssignmentStateModel;
  public url: string;
  public safeURL: SafeResourceUrl;

  constructor(
    public sanitizer: DomSanitizer,
    private store: Store,
    private assignmentService: AssignmentService
  ) {
    this.listenStoreChanges();
  }

  public ngOnInit(): void {
    this.assignmentService.init();
  }

  public listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
      /* detect viewport change and update assignment URL */
      this.setURL();
    });
    this.store.select(AssignmentState).subscribe((assignment: AssignmentStateModel) => {
      this.assignment = assignment;
    });
    this.store.select(AssignmentState.getAssignmentUrl).subscribe(url => {
      LogService.writeLog(`Assignment url is changed ${url}`, LogLevel.INFO, LogResource.ASSIGNMENT);
      if (!url) {
        url = '';
      }
      this.url = url;
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    });
  }

  public assignmentLoadedHandler(): void {
    setTimeout(() => {
      if (!this.assignment.isFrameLoaded && this.url !== '') {
        this.store.dispatch(new AssignmentAction.SetFrameIsLoaded());
      }
    }, 2000);
  }

  public setURL(): void {
    /* do nothing if Iframe is fully loaded */
    if (!this.assignment?.isFrameLoaded) {

      if (this.classroom.selectedBoardTab === ViewportTab.ASSIGNMENT) { /* set assignment URL, if switched to assignment and Iframe is not fully loaded */
        this.url = this.assignment?.url;
      } else { /* drop Iframe, if switched from assignment and Iframe is not fully loaded */
        this.url = '';
      }
      /* set safe URL to bind to HTML */
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }
}
